/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "generateColorTokens", {
    enumerable: true,
    get: function() {
        return generateColorTokens;
    }
});
const _colors = require("../global/colors.js");
const generateColorTokens = (brand)=>({
        colorNeutralForeground1: _colors.grey[14],
        colorNeutralForeground1Hover: _colors.grey[14],
        colorNeutralForeground1Pressed: _colors.grey[14],
        colorNeutralForeground1Selected: _colors.grey[14],
        colorNeutralForeground2: _colors.grey[26],
        colorNeutralForeground2Hover: _colors.grey[14],
        colorNeutralForeground2Pressed: _colors.grey[14],
        colorNeutralForeground2Selected: _colors.grey[14],
        colorNeutralForeground2BrandHover: brand[80],
        colorNeutralForeground2BrandPressed: brand[70],
        colorNeutralForeground2BrandSelected: brand[80],
        colorNeutralForeground3: _colors.grey[38],
        colorNeutralForeground3Hover: _colors.grey[26],
        colorNeutralForeground3Pressed: _colors.grey[26],
        colorNeutralForeground3Selected: _colors.grey[26],
        colorNeutralForeground3BrandHover: brand[80],
        colorNeutralForeground3BrandPressed: brand[70],
        colorNeutralForeground3BrandSelected: brand[80],
        colorNeutralForeground4: _colors.grey[44],
        colorNeutralForegroundDisabled: _colors.grey[74],
        colorNeutralForegroundInvertedDisabled: _colors.whiteAlpha[40],
        colorBrandForegroundLink: brand[70],
        colorBrandForegroundLinkHover: brand[60],
        colorBrandForegroundLinkPressed: brand[40],
        colorBrandForegroundLinkSelected: brand[70],
        colorNeutralForeground2Link: _colors.grey[26],
        colorNeutralForeground2LinkHover: _colors.grey[14],
        colorNeutralForeground2LinkPressed: _colors.grey[14],
        colorNeutralForeground2LinkSelected: _colors.grey[14],
        colorCompoundBrandForeground1: brand[80],
        colorCompoundBrandForeground1Hover: brand[70],
        colorCompoundBrandForeground1Pressed: brand[60],
        colorBrandForeground1: brand[80],
        colorBrandForeground2: brand[70],
        colorBrandForeground2Hover: brand[60],
        colorBrandForeground2Pressed: brand[30],
        colorNeutralForeground1Static: _colors.grey[14],
        colorNeutralForegroundStaticInverted: _colors.white,
        colorNeutralForegroundInverted: _colors.white,
        colorNeutralForegroundInvertedHover: _colors.white,
        colorNeutralForegroundInvertedPressed: _colors.white,
        colorNeutralForegroundInvertedSelected: _colors.white,
        colorNeutralForegroundInverted2: _colors.white,
        colorNeutralForegroundOnBrand: _colors.white,
        colorNeutralForegroundInvertedLink: _colors.white,
        colorNeutralForegroundInvertedLinkHover: _colors.white,
        colorNeutralForegroundInvertedLinkPressed: _colors.white,
        colorNeutralForegroundInvertedLinkSelected: _colors.white,
        colorBrandForegroundInverted: brand[100],
        colorBrandForegroundInvertedHover: brand[110],
        colorBrandForegroundInvertedPressed: brand[100],
        colorBrandForegroundOnLight: brand[80],
        colorBrandForegroundOnLightHover: brand[70],
        colorBrandForegroundOnLightPressed: brand[50],
        colorBrandForegroundOnLightSelected: brand[60],
        colorNeutralBackground1: _colors.white,
        colorNeutralBackground1Hover: _colors.grey[96],
        colorNeutralBackground1Pressed: _colors.grey[88],
        colorNeutralBackground1Selected: _colors.grey[92],
        colorNeutralBackground2: _colors.grey[98],
        colorNeutralBackground2Hover: _colors.grey[94],
        colorNeutralBackground2Pressed: _colors.grey[86],
        colorNeutralBackground2Selected: _colors.grey[90],
        colorNeutralBackground3: _colors.grey[96],
        colorNeutralBackground3Hover: _colors.grey[92],
        colorNeutralBackground3Pressed: _colors.grey[84],
        colorNeutralBackground3Selected: _colors.grey[88],
        colorNeutralBackground4: _colors.grey[94],
        colorNeutralBackground4Hover: _colors.grey[98],
        colorNeutralBackground4Pressed: _colors.grey[96],
        colorNeutralBackground4Selected: _colors.white,
        colorNeutralBackground5: _colors.grey[92],
        colorNeutralBackground5Hover: _colors.grey[96],
        colorNeutralBackground5Pressed: _colors.grey[94],
        colorNeutralBackground5Selected: _colors.grey[98],
        colorNeutralBackground6: _colors.grey[90],
        colorNeutralBackgroundInverted: _colors.grey[16],
        colorNeutralBackgroundStatic: _colors.grey[20],
        colorNeutralBackgroundAlpha: _colors.whiteAlpha[50],
        colorNeutralBackgroundAlpha2: _colors.whiteAlpha[80],
        colorSubtleBackground: 'transparent',
        colorSubtleBackgroundHover: _colors.grey[96],
        colorSubtleBackgroundPressed: _colors.grey[88],
        colorSubtleBackgroundSelected: _colors.grey[92],
        colorSubtleBackgroundLightAlphaHover: _colors.whiteAlpha[70],
        colorSubtleBackgroundLightAlphaPressed: _colors.whiteAlpha[50],
        colorSubtleBackgroundLightAlphaSelected: 'transparent',
        colorSubtleBackgroundInverted: 'transparent',
        colorSubtleBackgroundInvertedHover: _colors.blackAlpha[10],
        colorSubtleBackgroundInvertedPressed: _colors.blackAlpha[30],
        colorSubtleBackgroundInvertedSelected: _colors.blackAlpha[20],
        colorTransparentBackground: 'transparent',
        colorTransparentBackgroundHover: 'transparent',
        colorTransparentBackgroundPressed: 'transparent',
        colorTransparentBackgroundSelected: 'transparent',
        colorNeutralBackgroundDisabled: _colors.grey[94],
        colorNeutralBackgroundInvertedDisabled: _colors.whiteAlpha[10],
        colorNeutralStencil1: _colors.grey[90],
        colorNeutralStencil2: _colors.grey[98],
        colorNeutralStencil1Alpha: _colors.blackAlpha[10],
        colorNeutralStencil2Alpha: _colors.blackAlpha[5],
        colorBackgroundOverlay: _colors.blackAlpha[40],
        colorScrollbarOverlay: _colors.blackAlpha[50],
        colorBrandBackground: brand[80],
        colorBrandBackgroundHover: brand[70],
        colorBrandBackgroundPressed: brand[40],
        colorBrandBackgroundSelected: brand[60],
        colorCompoundBrandBackground: brand[80],
        colorCompoundBrandBackgroundHover: brand[70],
        colorCompoundBrandBackgroundPressed: brand[60],
        colorBrandBackgroundStatic: brand[80],
        colorBrandBackground2: brand[160],
        colorBrandBackground2Hover: brand[150],
        colorBrandBackground2Pressed: brand[130],
        colorBrandBackground3Static: brand[60],
        colorBrandBackground4Static: brand[40],
        colorBrandBackgroundInverted: _colors.white,
        colorBrandBackgroundInvertedHover: brand[160],
        colorBrandBackgroundInvertedPressed: brand[140],
        colorBrandBackgroundInvertedSelected: brand[150],
        colorNeutralCardBackground: _colors.grey[98],
        colorNeutralCardBackgroundHover: _colors.white,
        colorNeutralCardBackgroundPressed: _colors.grey[96],
        colorNeutralCardBackgroundSelected: _colors.grey[92],
        colorNeutralCardBackgroundDisabled: _colors.grey[94],
        colorNeutralStrokeAccessible: _colors.grey[38],
        colorNeutralStrokeAccessibleHover: _colors.grey[34],
        colorNeutralStrokeAccessiblePressed: _colors.grey[30],
        colorNeutralStrokeAccessibleSelected: brand[80],
        colorNeutralStroke1: _colors.grey[82],
        colorNeutralStroke1Hover: _colors.grey[78],
        colorNeutralStroke1Pressed: _colors.grey[70],
        colorNeutralStroke1Selected: _colors.grey[74],
        colorNeutralStroke2: _colors.grey[88],
        colorNeutralStroke3: _colors.grey[94],
        colorNeutralStrokeSubtle: _colors.grey[88],
        colorNeutralStrokeOnBrand: _colors.white,
        colorNeutralStrokeOnBrand2: _colors.white,
        colorNeutralStrokeOnBrand2Hover: _colors.white,
        colorNeutralStrokeOnBrand2Pressed: _colors.white,
        colorNeutralStrokeOnBrand2Selected: _colors.white,
        colorBrandStroke1: brand[80],
        colorBrandStroke2: brand[140],
        colorBrandStroke2Hover: brand[120],
        colorBrandStroke2Pressed: brand[80],
        colorBrandStroke2Contrast: brand[140],
        colorCompoundBrandStroke: brand[80],
        colorCompoundBrandStrokeHover: brand[70],
        colorCompoundBrandStrokePressed: brand[60],
        colorNeutralStrokeDisabled: _colors.grey[88],
        colorNeutralStrokeInvertedDisabled: _colors.whiteAlpha[40],
        colorTransparentStroke: 'transparent',
        colorTransparentStrokeInteractive: 'transparent',
        colorTransparentStrokeDisabled: 'transparent',
        colorNeutralStrokeAlpha: _colors.blackAlpha[5],
        colorNeutralStrokeAlpha2: _colors.whiteAlpha[20],
        colorStrokeFocus1: _colors.white,
        colorStrokeFocus2: _colors.black,
        colorNeutralShadowAmbient: 'rgba(0,0,0,0.12)',
        colorNeutralShadowKey: 'rgba(0,0,0,0.14)',
        colorNeutralShadowAmbientLighter: 'rgba(0,0,0,0.06)',
        colorNeutralShadowKeyLighter: 'rgba(0,0,0,0.07)',
        colorNeutralShadowAmbientDarker: 'rgba(0,0,0,0.20)',
        colorNeutralShadowKeyDarker: 'rgba(0,0,0,0.24)',
        colorBrandShadowAmbient: 'rgba(0,0,0,0.30)',
        colorBrandShadowKey: 'rgba(0,0,0,0.25)'
    });
